// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq[data-v-2eaf1368]{padding:1em 1em 7em}.question[data-v-2eaf1368]{font-size:1.5em;font-weight:500;line-height:1.3}article[data-v-2eaf1368]{max-width:calc(100vw - 2em);min-height:90vh;overflow:hidden}.faq .answer[data-v-2eaf1368]{font-size:var(--body)}.faq .answer[data-v-2eaf1368] p{line-height:1.4}.answer[data-v-2eaf1368] ul{margin-bottom:1em}.answer[data-v-2eaf1368] li{display:list-item;list-style:disc inside}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
